import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    title: {
      ...theme.eatclub.typography.cancelTitle,
      maxWidth: '700px',
    },
    mainContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '34px',
      lineHeight: '1.4',
    },
    pageContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '60px',
      fontSize: '18px',
      maxWidth: '620px',
    },
    dropdownContainer: {
      fontSize: '16px',
      // maxWidth: '350px',
    },
    dynamicContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '40px',
    },
  }),
  { name: 'CancelReasonPage' },
);

export default useStyles;

export const toggleGroupStyles = {
  label: {
    paddingBottom: '24px',
    margin: 0,
  },
  option: {
    flexGrow: 1,
    textAlign: 'center',
    justifyContent: 'center',
    border: '1px solid #E1D7C8',
    borderRadius: '8px',
    backgroundColor: 'transparent',
    padding: '10px 20px',
    fontSize: '15px',
  },
  hoveredOption: {
    border: '1px solid #313131',
  },
  selectedOption: {
    border: '1px solid black',
    outline: '1px solid black',
  },
};

export const verticalToggleGroupStyles = {
  groupContainer: {
    gap: '12px',
    flexDirection: 'column',
  },
  groupOptionContainer: {
    width: 'fit-content',
  },
  label: {
    paddingBottom: '24px',
    margin: 0,
  },
  option: {
    textAlign: 'left',
    justifyContent: 'flex-start',
    border: '1px solid #E1D7C8',
    borderRadius: '8px',
    backgroundColor: 'transparent',
    padding: '10px 20px 8px 10px',
    fontSize: '15px',
  },
  optionLabel: {
    // marginTop: '1px',
  },
  iconContainer: {
    position: 'relative',
    height: '16px',
    width: '16px',
    border: '1px solid #E1D7C8',
    borderRadius: '20px',
  },
  iconContainerSelected: {
    backgroundColor: '#282525',
  },
  hoveredOption: {
    border: '1px solid #313131',
  },
  selectedOption: {
    border: '1px solid black',
    // outline: '1px solid black',
  },
};

export const textFieldStyles = {
  label: { marginBottom: 0 },
  innerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '24px',
    width: '100%',
  },
  textField: { flexGrow: 1 },
};

export const textAreaStyles = {
  label: { paddingBottom: '24px', marginBottom: 0 },
  textField: { backgroundColor: 'white' },
  textArea: { borderRadius: '12px', border: '1px solid #EBEBEB' },
};
